import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    cardContainer: {
      display: 'flex',
      minHeight: 90,
      width: 400,
      backgroundColor: '#fff',
      boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
      borderRadius: '2px',
      marginBottom: '15px',
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 90,
      minHeight: 90,
      backgroundColor: '#05A4D8',
      borderRadius: '2px 0 0 2px',
      flexShrink: 0,
    },
    icon: {
      color: '#fff',
      fontSize: 45,
    },
    content: {
      padding: theme.spacing(1, 2),
      flex: 1,
      minWidth: 0,
    },
    header: {
      fontSize: 16,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      pb: 1,
    },
    readMode: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    readValue: {
      fontSize: 13,
      color: '#333',
      padding: '4px',
    },
    formControl: {
      mt: 0.5,
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 1,
      pt: 1,
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      py: 2,
    },
  };
};
